import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";
import { api } from "@/lib/api";
import Reveal from "@/components/Reveal";

export default function BlogPost() {
  const { slug } = useParams();
  const { t, localize } = useLanguage();
  const [post, setPost] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    api.post(slug).then(setPost).catch(() => setError(true));
  }, [slug]);

  if (error) {
    return (
      <div className="flex min-h-screen items-center justify-center pt-32">
        <p data-testid="post-error" className="text-sm text-navy/50">{t.common.error}</p>
      </div>
    );
  }
  if (!post) {
    return (
      <div className="flex min-h-screen items-center justify-center pt-32">
        <p data-testid="post-loading" className="text-sm text-navy/50">{t.common.loading}</p>
      </div>
    );
  }
  const loc = localize(post.i18n);

  return (
    <div data-testid="blog-post-page" className="bg-white pt-28">
      <div className="mx-auto max-w-3xl px-6 pb-24">
        <Link
          to="/blog"
          data-testid="post-back-link"
          className="group inline-flex items-center gap-2 text-[11px] font-semibold uppercase tracking-[0.18em] text-navy/50 transition-colors hover:text-gold-dark"
        >
          <ArrowLeft size={14} className="transition-transform group-hover:-translate-x-1 rtl:rotate-180 rtl:group-hover:translate-x-1" />
          {t.blog.backB}
        </Link>
        <Reveal>
          <p className="label-luxe mt-10 text-sage-dark">{post.date} · 4 {t.blog.min}</p>
          <h1 data-testid="post-title" className="mt-5 font-display text-4xl font-light leading-tight tracking-tight text-navy sm:text-5xl">
            {loc.title}
          </h1>
        </Reveal>
        <Reveal delay={1}>
          <div className="img-zoom-frame mt-12 border border-navy/10">
            <img src={post.image} alt={loc.title} data-testid="post-image" className="aspect-[16/9] w-full object-cover" />
          </div>
        </Reveal>
        <div className="mt-12 space-y-6">
          {(loc.body || []).map((p, i) => (
            <Reveal key={i} delay={i}>
              <p data-testid={`post-paragraph-${i}`} className="text-base font-light leading-relaxed text-navy/70">{p}</p>
            </Reveal>
          ))}
        </div>
        <div className="gold-hairline mt-16" />
        <Reveal className="mt-10 text-center">
          <Link to="/shop" data-testid="post-cta-shop" className="btn-outline-luxe">{t.actions.shopNow}</Link>
        </Reveal>
      </div>
    </div>
  );
}
